export enum TypeCommunicationEnum {
  Alltypes = 1,
  Offline,
  Online
}
